import { createContext, useState, useContext, useEffect, useRef } from "react";

const AppContext = createContext()
export const AppProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    diameter: 200,
    length: 2000,
    inletqty: 1,
    inletp1: 0,
    inletp2: 322,
    inletp3: 644,
    outletqty: 1,
    outletp1: 0,
    outletp2: 252,
    outletp3: 504
  });
  const [change, setChange] = useState(false)
  const [objdata, setObjdata] = useState([])
  const [showall, setShowall] = useState(false)
  const [partname, setPartname] = useState("")
  const [material, setMaterial] = useState("Carbon Steel")
  const [shadowvisible, setShadowVisible] = useState(true)
  const [inletuuids, setInletuuids] = useState([])
  const [outletuuids, setOutletuuids] = useState([])
  const [highlightingtext, setHighlightingText] = useState('')
  const [loadingSet, setLoadingSet] = useState(new Set())

  const prevLengthRef = useRef(formData.length);

  useEffect(() => {
    if (prevLengthRef.current !== formData.length) {
      prevLengthRef.current = formData.length;
      setShadowVisible(true);
      setPartname("");
      setObjdata([]);
      setOutletuuids([]);
      setInletuuids([]);
      setHighlightingText('');
    }
  }, [formData.length]);

  const addLoadingId = (id) => {
    setLoadingSet((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  };

  const removeLoadingId = (id) => {
    setLoadingSet((prev) => {
      if (!prev.has(id)) return prev;
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  var diameter = formData.diameter;
  var length = formData.length

  var troughtsection2000, qty2000;

  if (diameter == 200) {
    if (length == 2000 || length == 5000 || length == 8000 || length == 11000) {
      troughtsection2000 = "VågenExpress.Ø200.69.51 Trough section 2000 mm"
      qty2000 = 1

    }
    if (length == 4000 || length == 7000 || length == 10000) {
      troughtsection2000 = "VågenExpress.Ø200.69.51 Trough section 2000 mm"
      qty2000 = 2
    }
  }


  if (diameter == 300) {
    if (length == 2000 || length == 5000 || length == 8000 || length == 11000) {
      troughtsection2000 = "VågenExpress.Ø300.69.51 Trough section 2000 mm"
      qty2000 = 1
    }
    if (length == 4000 || length == 7000 || length == 10000) {
      troughtsection2000 = "VågenExpress.Ø300.69.51 Trough section 2000 mm"
      qty2000 = 2
    }
  }

  var troughtsection3000, qty3000;
  // diameter200
  if (diameter == 200) {
    if (length == 3000 || length == 5000 || length == 7000) {
      troughtsection3000 = "VågenExpress.Ø200.69.23.51 Trough section 3000 mm"
      qty3000 = 1
    }

    if (length == 6000 || length == 8000 || length == 10000) {
      troughtsection3000 = "VågenExpress.Ø200.69.23.51 Trough section 3000 mm"
      qty3000 = 2
    }


    if (length == 9000 || length == 11000) {
      troughtsection3000 = "VågenExpress.Ø200.69.23.51 Trough section 3000 mm"
      qty3000 = 3
    }
    if (length == 12000) {
      troughtsection3000 = "VågenExpress.Ø200.69.23.51 Trough section 3000 mm"
      qty3000 = 4
    }
  }
  // diameter300
  if (diameter == 300) {
    if (length == 3000 || length == 5000 || length == 7000) {
      troughtsection3000 = "VågenExpress.Ø300.69.51 Trough section 3000 mm"
      qty3000 = 1
    }

    if (length == 6000 || length == 8000 || length == 10000) {
      troughtsection3000 = "VågenExpress.Ø300.69.51 Trough section 3000 mm"
      qty3000 = 2
    }

    if (length == 9000 || length == 11000) {
      troughtsection3000 = "VågenExpress.Ø300.69.51 Trough section 3000 mm"
      qty3000 = 3
    }

    if (formData.length == 12000) {
      troughtsection3000 = "VågenExpress.Ø300.69.51 Trough section 3000 mm"
      qty3000 = 4
    }
  }



  var bearing, bearingqty;



  if (formData.length == 4000 || formData.length == 5000 || formData.length == 6000) {

    bearing = formData.diameter == 200 ? "VågenExpress.Ø200.69.49 Intermediate bearing" : "VågenExpress.Ø300.69.49 Intermediate bearing"
    bearingqty = 1
  }
  if (formData.length == 7000 || formData.length == 8000 || formData.length == 9000) {
    bearing = formData.diameter == 200 ? "VågenExpress.Ø200.69.49 Intermediate bearing" : "VågenExpress.Ø300.69.49 Intermediate bearing"
    bearingqty = 2

  }
  if (formData.length == 10000 || formData.length == 11000 || formData.length == 12000) {
    bearing = formData.diameter == 200 ? "VågenExpress.Ø200.69.49 Intermediate bearing" : "VågenExpress.Ø300.69.49 Intermediate bearing"
    bearingqty = 3

  }

  var kw;
  if (formData.diameter == 200) {
    if (formData.length <= 6000) {
      kw = '2.2'
    } else {
      kw = '3.0'
    }
  }
  if (formData.diameter == 300) {
    if (formData.length <= 6000) {
      kw = '3.0'
    } else {
      kw = '5.5'
    }
  }


  var bommaterial;
  if (material === "Carbon Steel") {
    bommaterial = "carbon steel"
  } else if (material === "Stainless Steel") {
    bommaterial = "stainless steel"
  }

  const tabledata = [
    { partnumber: formData.diameter == 200 ? `VågenExpress.Ø200.69.48 Drive station ${kw} kW 2022` : `VågenExpress.Ø300.69.48 Drive station ${kw} kW 2022`, description: "-", qty: 1 },
    { partnumber: formData.diameter == 200 ? `VågenExpress.Ø200.69.48 End station ${bommaterial}` : `VågenExpress.Ø300.69.48 End station ${bommaterial}`, description: material, qty: 1 },
    { partnumber: `${troughtsection2000} ${bommaterial}`, description: material, qty: qty2000 },
    { partnumber: `${troughtsection3000} ${bommaterial}`, description: material, qty: qty3000 },
    { partnumber: `${bearing} 2022`, description: "-", qty: bearingqty },
    { partnumber: `VågenExpress.${formData.diameter == 200 ? "Ø200" : "Ø300"}.69.23.507 Inlet`, description: "-", qty: formData.inletqty },
    { partnumber: `VågenExpress.${formData.diameter == 200 ? "Ø200" : "Ø300"}.69.23.508 Outlet`, description: "-", qty: formData.outletqty },
  ]
  const filtertabledata = tabledata.filter(item => item.partnumber !== undefined && item.qty !== undefined);


  return <AppContext.Provider value={{
    formData,
    setFormData,
    change,
    setChange,
    objdata,
    setObjdata,
    showall,
    setShowall,
    partname,
    setPartname,
    shadowvisible,
    setShadowVisible,
    filtertabledata,
    material,
    setMaterial,
    inletuuids,
    setInletuuids,
    outletuuids,
    setOutletuuids,
    highlightingtext, setHighlightingText,
    loadingSet,
    addLoadingId,
    removeLoadingId,
  }}>
    {children}
  </AppContext.Provider>
}
export const useGlobalcontext = () => {
  return useContext(AppContext)
}